interface TranscriptLanguageSwitchProps {
  languages: string[];
  active: string | null;
  original: string | null;
  onChange: (lang: string | null) => void;
  disabled?: boolean;
}

function formatLanguageLabel(code: string): string {
  try {
    const display = new Intl.DisplayNames([navigator.language], { type: 'language' }).of(code);
    if (display && display !== code) return display;
  } catch {
    // fall through
  }
  return code.toUpperCase();
}

export function TranscriptLanguageSwitch({
  languages,
  active,
  original,
  onChange,
  disabled = false,
}: TranscriptLanguageSwitchProps) {
  if (languages.length < 2) return null;

  return (
    <div className="flex items-center gap-1">
      {languages.map((lang, index) => {
        const isOriginalPlaceholder = original === null && index === 0;
        const isOriginal = lang === original || isOriginalPlaceholder;
        const isActive = isOriginal ? active === null : active === lang;
        const label = isOriginalPlaceholder
          ? 'Original'
          : `${formatLanguageLabel(lang)}${isOriginal ? ' (original)' : ''}`;

        return (
          <button
            key={lang}
            type="button"
            onClick={() => onChange(isOriginal ? null : lang)}
            disabled={disabled}
            className={`text-xs px-2 py-1 rounded border transition-colors ${
              isActive
                ? 'bg-gray-900 text-white border-gray-900'
                : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'
            } disabled:opacity-50 disabled:cursor-not-allowed`}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
}
